module.exports = __webpack_public_path__ + "img/home-fqa-mountain.d3508c18.png";